import type { CommonsInitializeType } from '../startup/types';

export default class ConfigurationManager {
  private static _config: Record<string, any> = {};

  static initialize(config: CommonsInitializeType, keys: string[]): void {
    keys.forEach((key) => {
      this.setProps(key, config[key as keyof CommonsInitializeType]);
    });
  }

  static getProps(key: string) {
    return ConfigurationManager._config[key];
  }

  static setProps(key: string, value: any): void {
    ConfigurationManager._config[key] = value;
  }

  /** @internal Test helper — do not use in production code */
  static _reset(): void {
    ConfigurationManager._config = {};
  }
}
